export function safeDecode(maybeEncoded) {
    try {
        return decodeURI(maybeEncoded);
    }
    catch {
        return maybeEncoded;
    }
}
